import { z } from 'zod';
import { dateDmySchema, nonEmptyTrimmed } from './primitives.js';

export const occupationSchema = z.object({
  sector: nonEmptyTrimmed('Sector', 120),
  role: nonEmptyTrimmed('Job role', 160),
  startDate: dateDmySchema,
  cis: z.boolean(),
});

export type Occupation = z.infer<typeof occupationSchema>;
